import {
  ColorPickerComponent,
  NumericTextBoxComponent,
} from '@syncfusion/ej2-react-inputs';
import { ButtonPropsModel } from '@syncfusion/ej2-react-popups';
import { useEffect, useState } from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import {
  DeleteKanbanColor,
  EditKanbanColor,
  GetKanbanColor,
} from '../../../services/CloudScheduler/CloudSchedulerServices';
import Message from '../../../utils/Message/Message';
import '../../Settings/KanBan/kanban.css';
import { all_information } from '../../../App';
import GlobalDialog from '../../../components/GlobalDialog';
import { BiAddToQueue } from 'react-icons/bi';

let buttonsPopup: ButtonPropsModel[];
let current_data: any = [];
function Priority() {
  const [colorData, setColorData] = useState<Array<any>>([]);
  const [hideDialog, setHideDialog] = useState(false);
  const [currentColor, setCurrentColor] = useState<string>('');
  const [currentPriority, setCurrentPriority] = useState(0);
  const [isAddOp, setIsAddOp] = useState(false);
  buttonsPopup = [
    {
      click: () => {
        saveColor();
      },
      buttonModel: {
        content: 'Accept',
        isPrimary: true,
      },
    },
    {
      click: () => {
        setHideDialog(false);
      },
      buttonModel: {
        content: 'Cancel',
      },
    },
  ];

  const saveColor = () => {
    var findElement = colorData.findIndex((el) => {
      return (
        (el?.priority_color === currentColor ||
          Number(el.priority_code.trim()) === currentPriority) &&
        el.priority_id !== current_data.priority_id
      );
    });
    if (findElement !== -1) {
      Message.warning('Color and Priority must be uniq');
      return;
    }
    var theObj: any = {
      app: 'UWORK',
      organization_id: all_information.company_id?.toString(),
      user_id: all_information.user_id,
      priority_id: current_data.priority_id,
      priority_code: currentPriority.toString(),
      priority_color: currentColor,
    };
    setHideDialog(false);
    if (isAddOp) delete theObj.priority_id;
    EditKanbanColor(theObj)
      .then((el) => {
        getColor();
        Message.success('Success');
      })
      .catch((er) => {
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  };
  const getColor = () => {
    GetKanbanColor(all_information.company_id?.toString()).then((el) => {
      setColorData(el.data);
    });
  };
  const onEdit = (args: any) => {
    setIsAddOp(false);
    current_data = args;
    setHideDialog(true);
    setCurrentColor(args?.priority_color);
    setCurrentPriority(Number(args.priority_code.trim()));
  };
  const onDelete = (args: any) => {
    current_data = args;
    DeleteKanbanColor({ priority_id: current_data.priority_id })
      .then((el) => {
        getColor();
        Message.success('Success');
      })
      .catch((er) => {
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  };
  const onAdd = () => {
    setIsAddOp(true);
    setHideDialog(true);
    setCurrentColor('');
  };
  useEffect(() => {
    getColor();
  }, []);
  return (
    <div>
      <div className='prioraty container'>
        <div className='eachHeader'>
          <span>Priority Settings</span>
        </div>
        <div className='prioraty-content'>
          {colorData.map((el) => {
            return (
              <div
                className='each-prioraty-card'
                style={{ backgroundColor: el?.priority_color }}
                key={el.priority_id}
              >
                <span
                  style={{
                    fontSize: '40px',
                  }}
                >
                  {Number(el.priority_code)}
                </span>
                <button className='eachButton' onClick={onEdit.bind({}, el)}>
                  <FaEdit />
                  Edit
                </button>
                <button
                  className='eachButton'
                  onClick={onDelete.bind({}, el)}
                  style={{ marginTop: 5 }}
                >
                  <FaTrash />
                  Delete
                </button>
              </div>
            );
          })}
          <div
            className='each-prioraty-card'
            style={{ backgroundColor: 'grey' }}
            key={Math.random()}
          >
            <button className='eachButton' onClick={onAdd.bind({})}>
              <BiAddToQueue size={40} />
              Add
            </button>
          </div>
        </div>
      </div>
      {hideDialog ? (
        <GlobalDialog
          showDialog={hideDialog}
          setShowDialog={(val: boolean) => setHideDialog(val)}
          header={`Priority`}
          width={300}
          buttons={buttonsPopup}
          hideDoneButton={true}
        >
          <div className='container'>
            <div
              style={{
                justifyContent: 'space-between',
                flexDirection: 'column',
                display: 'flex',
              }}
            >
              <div style={{ marginBottom: 30 }}>
                <NumericTextBoxComponent
                  value={currentPriority}
                  max={10}
                  min={0}
                  placeholder='Priority Number'
                  floatLabelType='Always'
                  format='N'
                  onChange={(args: any) => {
                    setCurrentPriority(args.target.value);
                  }}
                />
              </div>

              <ColorPickerComponent
                style={{ marginTop: 40, zIndex: 999999 }}
                value={currentColor}
                onChange={(args: any) => {
                  // setState({ currentColor: args.value });
                }}
                select={(args: any) => {
                  setCurrentColor(args.currentValue.hex);
                }}
              />
            </div>
          </div>
        </GlobalDialog>
      ) : null}
    </div>
  );
}

export default Priority;
